'use client';

import { c as _c } from "react/compiler-runtime";
import { createBackerRewardScope, useGetBackerRewards, useIsFetchedThisSession } from '@morfi/backend-sdk-v2/client';
import { type ReactNode, useEffect } from 'react';
import { PORTFOLIO_REWARD_FIELDS } from '@/lib/sdk/projections';
import { logger } from '@/lib/telemetry/logger';
export interface PortfolioRewardSource {
  readonly wallet: string | null;
  readonly query: ReturnType<typeof useGetBackerRewards>;
  readonly fresh: boolean;
}
export function PortfolioRewardsSources(t0) {
  const $ = _c(16);
  const {
    identities,
    walletPubkeys,
    own,
    sources: t1,
    children
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sources = t2;
  const identity = identities[0];
  if (identity === undefined) {
    let t3;
    if ($[2] !== children || $[3] !== sources) {
      t3 = children(sources);
      $[2] = children;
      $[3] = sources;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== children || $[6] !== identities || $[7] !== own || $[8] !== sources || $[9] !== walletPubkeys) {
    t3 = source => <PortfolioRewardsSources identities={identities.slice(1)} walletPubkeys={walletPubkeys} own={own} sources={[...sources, source]}>{children}</PortfolioRewardsSources>;
    $[5] = children;
    $[6] = identities;
    $[7] = own;
    $[8] = sources;
    $[9] = walletPubkeys;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== identity || $[12] !== own || $[13] !== t3 || $[14] !== walletPubkeys) {
    t4 = <WalletRewardsSource identity={identity} walletPubkeys={walletPubkeys} own={own}>{t3}</WalletRewardsSource>;
    $[11] = identity;
    $[12] = own;
    $[13] = t3;
    $[14] = walletPubkeys;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function WalletRewardsSource(t0) {
  const $ = _c(24);
  const {
    identity,
    walletPubkeys,
    own,
    children
  } = t0;
  let t1;
  if ($[0] !== identity || $[1] !== own || $[2] !== walletPubkeys) {
    t1 = own ? [identity] : walletPubkeys;
    $[0] = identity;
    $[1] = own;
    $[2] = walletPubkeys;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const wallets = t1;
  let t2;
  if ($[4] !== identity || $[5] !== wallets) {
    t2 = createBackerRewardScope(identity, wallets);
    $[4] = identity;
    $[5] = wallets;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== wallets) {
    t3 = wallets.join(",");
    $[7] = wallets;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== identity || $[10] !== t2 || $[11] !== t3) {
    t4 = {
      userId: identity,
      rewardScope: t2,
      walletPubkeysCsv: t3,
      limit: "100",
      fields: PORTFOLIO_REWARD_FIELDS
    };
    $[9] = identity;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = identity.length > 0;
  let t6;
  if ($[13] !== t5) {
    t6 = {
      enabled: t5
    };
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const query = useGetBackerRewards(t4, t6);
  const fresh = useIsFetchedThisSession(query.queryKey);
  const failed = query.isError;
  let t7;
  let t8;
  if ($[15] !== failed || $[16] !== own) {
    t7 = () => {
      if (failed) {
        logger.warn("portfolio.rewards.load_failed", {
          source: "backer_rewards",
          viewerMode: own ? "own" : "other"
        });
      }
    };
    t8 = [failed, own];
    $[15] = failed;
    $[16] = own;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  useEffect(t7, t8);
  const t9 = own ? identity : null;
  let t10;
  if ($[19] !== children || $[20] !== fresh || $[21] !== query || $[22] !== t9) {
    t10 = children({
      wallet: t9,
      query,
      fresh
    });
    $[19] = children;
    $[20] = fresh;
    $[21] = query;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}